import React, { useEffect, useState } from 'react';
import MainApp from './MainApp';
import Login from './Login';
import UserAdmin from './UserAdmin';
import ProfileDialog from './ProfileDialog';
import { apiFetch, authToken, saveAuthToken } from './api';

const App = () => {
  const [user, setUser] = useState(undefined);
  const [showUsers, setShowUsers] = useState(false);
  const [showProfile, setShowProfile] = useState(false);

  const logout = () => {
    // The remembered live list is per browser session (see liveScreenSessionKey
    // in MainApp), so a deliberate logout clears it and the next login opens on
    // Springout. Keys are per username, so every one of them goes.
    try {
      Object.keys(sessionStorage)
        .filter((key) => key.startsWith('screenerLiveScreen:'))
        .forEach((key) => sessionStorage.removeItem(key));
    } catch (_error) { /* private mode */ }
    saveAuthToken('');
    setShowUsers(false);
    setShowProfile(false);
    setUser(null);
  };

  useEffect(() => {
    const expired = () => logout();
    window.addEventListener('screener-auth-expired', expired);
    if (!authToken()) {
      setUser(null);
    } else {
      apiFetch('/api/auth/me')
        .then(async (response) => {
          const body = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(body.error || 'Login expired');
          setUser(body.user);
        })
        .catch(() => logout());
    }
    return () => window.removeEventListener('screener-auth-expired', expired);
  }, []);

  if (user === undefined) return <div className="auth-loading">Checking login…</div>;
  if (!user) return <Login onLogin={setUser} />;

  return (
    <>
      <MainApp
        username={user.username}
        riskPerTrade={user.riskPerTrade}
        trainingRiskPerTrade={user.trainingRiskPerTrade}
        tradingChartTv={user.tradingChartTv !== false}
        liveAccess={user.liveAccess === true}
        onOpenProfile={() => setShowProfile(true)}
        onLogout={logout}
      />
      {showProfile && <ProfileDialog
        user={user}
        onUpdated={setUser}
        onManageUsers={() => { setShowProfile(false); setShowUsers(true); }}
        onClose={() => setShowProfile(false)}
      />}
      {showUsers && user.isAdmin && <UserAdmin onClose={() => setShowUsers(false)} />}
    </>
  );
};

export default App;
